<h4 style="text-decoration: underline">Détail pour {{statsForASpeaker[0]?.libelleComedienne}}</h4>
<div class=" mt-4 mb-2">
  <div class="row justify-content-between mt-2">
    <div class="col-5">
      <h5>Infos pour les séances vocal :</h5>
      <table class="table mt-1 table-sm">
        <thead>
        <tr>
          <th scope="col">Langue</th>
          <th scope="col">Catégorie</th>
          <th scope="col">Quantitée</th>
        </tr>
        </thead>
        @if (hasVocal) {
<tbody>
        @for (row of vocalRows; track row) {
<tr>
          <td>{{row.langue}}</td>
          <td>{{row.categorie}}</td>
          <td>{{getQuantityLabel(row)}}</td>
        </tr>
}
        </tbody>
}
        @if (!hasVocal) {
<tbody>
        <tr>
          <td colspan="3">Aucune séance vocale trouvée sur ce mois.</td>
        </tr>
        </tbody>
}
      </table>
    </div>
    <div class="col-5">
      <h5>Infos pour les séances de traduction :</h5>
      <table class="table mt-1 table-sm">
        <thead>
        <tr>
          <th scope="col">Langue</th>
          <th scope="col">Catégorie</th>
          <th scope="col">Quantitée</th>
        </tr>
        </thead>
        @if (hasTranslations) {
<tbody>
        @for (row of translationRows; track row) {
<tr>
          <td>{{row.langue}}</td>
          <td>{{row.categorie}}</td>
          <td>{{getQuantityLabel(row)}}</td>
        </tr>
}
        </tbody>
}
        @if (!hasTranslations) {
<tbody>
        <tr>
          <td colspan="2">Aucune séance de traduction trouvée sur ce mois.</td>
        </tr>
        </tbody>
}
      </table>
    </div>
  </div>
  <div class="row mt-2 align-items-end justify-content-center">
    @if (releve?.messagesMobilite?.length > 0) {
<div class="m-2">
      <h5>
        Relevé d'activité pour la mobilité :
      </h5>
      <div class="col-5">
        <table class="table mt-1 table-sm">
          <thead>
            <tr>
              <th scope="col">Langue</th>
              <th scope="col">Nombre</th>
            </tr>
          </thead>
          <tbody>
            @for (stat of releve?.messagesMobilite ; track stat) {
<tr>
              <td>{{stat.LANGUE}}</td>
              <td>{{stat.NB_MESSAGES}}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
    </div>
}
  </div>
</div>


